<template>
  <reflection-form v-bind:reflection="reflection"></reflection-form>
</template>

<script>
import { ReflectionsAPI } from "@/lib/api"
import User from "@/lib/user"
import EventBus from "@/lib/eventBus"
import ReflectionForm from "@/components/reflections/ReflectionForm"

export default {
  name: "ReflectionEntry",
  components: { ReflectionForm },
  data: function() {
    return {
      reflection: {}
    }
  },
  methods: {
    submit(reflection) {
      let userId = User.getUserId()
      let payload = {
        userId: userId,
        title: reflection.title,
        text: reflection.text
      }

      ReflectionsAPI.create(payload).then(() => {
        this.reflection.text = ""
        this.reflection.title = ""
        EventBus.$emit("ReflectionAdded")
        EventBus.$emit("flash", {
          text: "New Reflection Entered",
          type: "info",
          visible: true
        })
      })
    }
  },
  created() {
    EventBus.$on("reflection:submit", reflection => {
      this.submit(reflection)
    })
  }
}
</script>

<style lang="css" scoped>
.md-card {
  width: 100%;
  max-width: 800px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}
.no-word-wrap {
  white-space: pre-line;
}
</style>
